module.exports = "https://cdn.thelire.com/ins/resource/ads@3x.32df08ba954598d99121b08ed21571c0.png";